import { render, staticRenderFns } from "./MenuContainer.vue?vue&type=template&id=02f981de&scoped=true"
import script from "./MenuContainer.vue?vue&type=script&lang=js"
export * from "./MenuContainer.vue?vue&type=script&lang=js"
import style0 from "./MenuContainer.vue?vue&type=style&index=0&id=02f981de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f981de",
  null
  
)

export default component.exports